export default __webpack_public_path__ + "static/intro-cond-bold-italic-ced4c8b3dcd6dd5437f24b14e0a9a9aa.woff2";